"use client";
import { useTranslations } from "next-intl";
import CustomToast from "../../../common/components/CustomToast";
import Icon from "../../../common/components/Icon";
import Image from "next/image";
import Button from "../../../theme/components/Button";
import useCurrentUser from "../../../auth/hooks/useCurrentUser";
import * as matomo from "../../../analytics/utils/matomo";
import { usePathname } from "../../../../navigation";

const NewCartProductConfirmationToast = ({
  product,
  quantity,
  clientId,
  orderId,
  ...toastProps
}) => {
  const t = useTranslations();
  const { currentUser, userType } = useCurrentUser();
  const firstMediaUrl = product?.media?.[0]?.file?.url;
  const pathname = usePathname();
  return (
    <>
      <CustomToast
        {...toastProps}
        message={
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div>
              {firstMediaUrl && (
                <div style={{ minWidth: "48px" }}>
                  <Image
                    src={firstMediaUrl}
                    unoptimized // Disable Next.js loader because it's already a thumbnail from thumbor
                    alt=""
                    width={48}
                    height={48}
                    priority={false}
                    style={{ objectFit: "contain", objectPosition: "center" }}
                  />
                </div>
              )}
            </div>
            <div style={{ maxWidth: "260px" }}>
              <div>
                {product?.texts?.title}
                <div className="mt-2 color-secondary d-flex align-items-center gap-2">
                  <Icon icon="check-circle-filled" className="icon--mdl" />
                  {quantity} x {t("product_added_to_cart_success")}
                </div>
              </div>
              <div className="mt-1">{product?.texts?.subTitle}</div>
            </div>
          </div>
        }
        actions={
          <div className="d-flex gap-3">
            <Button
              appearance="primary"
              type="button"
              size="small"
              href={`/portal/checkout?clientId=${clientId}&orderId=${orderId}`}
              className="button--small"
            >
              <div>{t("checkout")}</div>
            </Button>
            <Button
              appearance="secondary"
              size="small"
              href={`/portal/${userType == "mediator" ? `client/${clientId}/cart` : "cart"}`}
              onClick={() => {
                matomo.trackEvent(
                  "Cart Open",
                  `${pathname} - (Toast)`,
                  currentUser?.self?.name,
                );
              }}
              className="button--small"
            >
              <div>{t("to_cart")}</div>
            </Button>
          </div>
        }
      />
    </>
  );
};

export default NewCartProductConfirmationToast;
